import type { PropValueOrDerived } from "vanjs-core";
import { locale } from "../locale";
import { div, option, select } from "./van-tags";

interface OnOffSelectParams {
	disabled?: PropValueOrDerived;
	isOn: () => boolean;
	setOn: (value: boolean) => void;
}

export function onOffSelect(cfg: OnOffSelectParams): HTMLDivElement {
	return div(
		{ class: "select" },
		select(
			{
				disabled: cfg.disabled || false,
				onchange: (e: Event) => {
					if (!(e.target instanceof HTMLSelectElement)) return;
					cfg.setOn(e.target.value === "on");
				},
			},
			option(
				{ value: "off", selected: () => !cfg.isOn() },
				locale.string({
					enGB: "Off",
					deDE: "Aus",
					frFR: "Éteint",
					svSE: "Av",
				}),
			),
			option(
				{ value: "on", selected: () => cfg.isOn() },
				locale.string({
					enGB: "On",
					deDE: "Ein",
					frFR: "Allumé",
					svSE: "På",
				}),
			),
		),
	);
}

interface OnOffSelectParamsDeprecated {
	disabled: boolean;
	on: boolean;
}

export function onOffSelectDeprecated(
	cfg: OnOffSelectParamsDeprecated,
): HTMLDivElement {
	return div(
		{ class: "select" },
		select(
			{
				disabled: () => cfg.disabled,
				onchange: (e) => {
					cfg.on = e.target.value === "on";
				},
			},
			option(
				{ value: "off", selected: () => !cfg.on },
				locale.string({
					enGB: "Off",
					deDE: "Aus",
					frFR: "Éteint",
					svSE: "Av",
				}),
			),
			option(
				{ value: "on", selected: () => cfg.on },
				locale.string({
					enGB: "On",
					deDE: "Ein",
					frFR: "Allumé",
					svSE: "På",
				}),
			),
		),
	);
}
